var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"max-height":"60vh","overflow":"auto"},attrs:{"flat":""}},[_c('pre',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.messages))])])}
var staticRenderFns = []

export { render, staticRenderFns }